(function () {
  if (window.__ksCartFeedback) return;
  window.__ksCartFeedback = true;

  const CART_COUNT_SELECTOR = 'cart-count.header__cart__status';
  const ANIMATION_CLASS = 'is-cart-count-updated';

  function disableAutoOpenCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer?.openCartDrawerOnProductAdded) return false;

    document.removeEventListener('theme:product:added', drawer.openCartDrawerOnProductAdded);
    return true;
  }

  function initDrawerGuard() {
    if (disableAutoOpenCartDrawer()) return;

    customElements.whenDefined('cart-drawer').then(() => {
      disableAutoOpenCartDrawer();
    });
  }

  function animateCartCounts() {
    document.querySelectorAll(CART_COUNT_SELECTOR).forEach((el) => {
      el.classList.remove(ANIMATION_CLASS);
      void el.offsetWidth;
      el.classList.add(ANIMATION_CLASS);
      el.addEventListener(
        'animationend',
        () => {
          el.classList.remove(ANIMATION_CLASS);
        },
        { once: true }
      );
    });
  }

  document.addEventListener('theme:product:added', animateCartCounts);
  initDrawerGuard();

  const ICON_BAG_SVG =
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-bag" viewBox="0 0 24 24">' +
    '<path d="m19.26 9.696 1.385 9A2 2 0 0 1 18.67 21H5.33a2 2 0 0 1-1.977-2.304l1.385-9A2 2 0 0 1 6.716 8h10.568a2 2 0 0 1 1.977 1.696zM14 5a2 2 0 1 0-4 0" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function ensureQuickAddIcon(btn) {
    if (btn.querySelector('.icon-bag')) return;

    const wrapper = document.createElement('span');
    wrapper.innerHTML = ICON_BAG_SVG;
    const icon = wrapper.firstElementChild;
    const textEl = btn.querySelector('.btn__text');

    if (textEl) {
      btn.insertBefore(icon, textEl);
      return;
    }

    btn.prepend(icon);
  }

  function upgradeQuickAddCards() {
    const ctaAdd = '加入購物車';
    const ctaSelect = '選擇規格';
    const holders = document.querySelectorAll(
      '.ksc-card .quick-add__holder, .product-item__image .quick-add__holder, .quick-add__holder--card'
    );

    holders.forEach((holder) => {
      const btn = holder.querySelector('button');
      if (!btn) return;

      const alreadyUpgraded = holder.dataset.ksQuickAddUpgraded === 'true';

      if (!alreadyUpgraded) {
        holder.dataset.ksQuickAddUpgraded = 'true';
        holder.classList.add('quick-add__holder--card', 'quick-add__holder--always-visible');
        holder.classList.remove('desktop', 'mobile');

        btn.classList.remove('look__dot__button', 'quick-add__button--mini');
        btn.classList.add('quick-add__button', 'quick-add__button--pill', 'btn', 'btn--solid', 'btn--small');
      }

      const label = btn.hasAttribute('data-quick-add-btn') ? ctaSelect : ctaAdd;
      let textEl = btn.querySelector('.btn__text');
      if (!textEl) {
        textEl = document.createElement('span');
        textEl.className = 'btn__text';
        const icon = btn.querySelector('.icon-bag');
        if (icon) {
          icon.after(textEl);
        } else {
          btn.prepend(textEl);
        }
      }
      textEl.textContent = label;
      ensureQuickAddIcon(btn);

      const card = holder.closest('.ksc-card');
      if (card) {
        card.classList.add('ksc-card--quick-add');
        return;
      }

      const productItem = holder.closest('.product-item');
      if (productItem) {
        productItem.classList.add('product-item--quick-add-card');
        const image = holder.closest('.product-item__image');
        if (image) image.classList.add('product-item__image--quick-add-card');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', upgradeQuickAddCards);
  } else {
    upgradeQuickAddCards();
  }

  document.addEventListener('shopify:section:load', upgradeQuickAddCards);
})();
